/**
 * @generated SignedSource<<7c4e9eb346c85c55358c251e74e46f49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingKindEnum = "agm" | "commitee" | "other" | "%future added value";
export type MeetingCreateInput = {
  clientMutationId?: string | null | undefined;
  meeting: MeetingCreateInputObject;
};
export type MeetingCreateInputObject = {
  clubId: string;
  date: any;
  defaultDescription?: boolean | null | undefined;
  kind: MeetingKindEnum;
  link?: string | null | undefined;
  name: string;
};
export type CreateMeetingForm_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: MeetingCreateInput;
};
export type CreateMeetingForm_Mutation$data = {
  readonly createMeeting: {
    readonly meeting: {
      readonly date: any | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly kind: MeetingKindEnum | null | undefined;
      readonly link: string | null | undefined;
      readonly name: string | null | undefined;
    };
  };
};
export type CreateMeetingForm_Mutation = {
  response: CreateMeetingForm_Mutation$data;
  variables: CreateMeetingForm_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Meeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateMeetingForm_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MeetingCreatePayload",
        "kind": "LinkedField",
        "name": "createMeeting",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateMeetingForm_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MeetingCreatePayload",
        "kind": "LinkedField",
        "name": "createMeeting",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "meeting",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "MeetingEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ecdcf6b9fab2365d18e8c63c18bf89c8",
    "id": null,
    "metadata": {},
    "name": "CreateMeetingForm_Mutation",
    "operationKind": "mutation",
    "text": "mutation CreateMeetingForm_Mutation(\n  $input: MeetingCreateInput!\n) {\n  createMeeting(input: $input) {\n    meeting {\n      id\n      name\n      link\n      description\n      date\n      kind\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea7169891ff7f880da62abc3962c137f";

export default node;
